export const getters = {
    loadingBranchen: state => state.loadingBranchen,
    errorBranchen: state => state.errorBranchen,
    branchen: state => state.branchen
}